<template ref="main">
  <div>
    <div v-if="cardObjects && cardObjects.length > 0">
      <div v-for="(card, cardIdx) in cardObjects" :key="'card-' + cardIdx">
        <h4 class="text-white mb-3">{{ card.title }}</h4>
        <div class="card-html" v-html="card.content"></div>
        <div class="mt-3">
          <vs-button
            class="mr-2 btn-success mb-3"
            v-for="(cta, ctaIdx) in card.ctas"
            :key="'b' + ctaIdx"
            @click="RaiseCta(cta, card)"
          >
            {{ cta }}
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      cardObjects: null,
    };
  },
  mounted() {
    // var cardsFound = [...this.$el.querySelectorAll("TCVCard")];
    var stringToReplaceHolder = document.createElement("div");
    stringToReplaceHolder.innerHTML = this.RawSettings;

    var cardsFound = [
      ...stringToReplaceHolder.querySelectorAll("TCVCard"),
    ].filter((cf) => cf.innerText.length > 0);

    if (cardsFound != null && cardsFound.length > 0) {
      this.$set(
        this,
        "cardObjects",
        cardsFound.map((c) => JSON.parse(c.innerHTML))
      );
    }
  },
  methods: {
    RaiseCta(cta, data) {
      this.$emit("RaiseCta", cta, data);
    },
  },
  props: ["RawSettings"],
};
</script>
<style>
.card-html li {
  list-style: decimal-leading-zero;
  list-style-position: outside;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 2em;
}

.card-html h1,
.card-html h2,
.card-html h3,
.card-html h4,
.card-html h5,
.card-html h6 {
  margin-bottom: 1.5em;
  margin-top: 1.5em;
  font-weight: 900;
}

.card-html {
  font-size: 1.2em;
}

.card-html p {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
